import { SVGProps } from "react"
const BalconyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.01624 10.9375V3.5C5.01624 2.94772 5.46395 2.5 6.01624 2.5H14.1563C14.7085 2.5 15.1562 2.94772 15.1562 3.5V10.9375M5.01624 10.9375H6.25M5.01624 10.9375H4.84375H4.10714M15.1562 10.9375H16.0937H17.5V16.0937H16.0937H14.6875M15.1562 10.9375H14.6875M14.6875 10.9375V16.0937M14.6875 10.9375H13.2812H11.875M14.6875 16.0937H13.2812H11.875M11.875 10.9375V16.0937M11.875 10.9375H10.4687H9.0625M11.875 16.0937H10.4687H9.0625M9.0625 10.9375V16.0937M9.0625 10.9375H7.65625H6.25M9.0625 16.0937H7.65625H6.25M6.25 10.9375V16.0937M6.25 16.0937H4.84375H4.10714M4.10714 16.0937H2.5V10.9375H3.4375H4.10714M4.10714 16.0937V10.9375"
      stroke={props.color || "#011727"}
    />
    <path d="M10 2.5V10.9375" stroke={props.color || "#011727"} />
    <rect
      x="2"
      y="16.0625"
      width="16"
      height="1.9375"
      rx="0.96875"
      stroke={props.color || "#011727"}
    />
  </svg>
)
export default BalconyIcon
